module.exports = __webpack_public_path__ + "img/b3.a11c6aef.png";